export interface MerchantCategoryInitializer {
  id: number;
  nameJA: string;
  nameEN: string;
  nameKO: string;
  displayOrder: number;
  imageUrl: string;
}

export enum MerchantCategoryId {
  Others = 16,
}

export default class MerchantCategory {
  public static PrimaryIds = [4, 3, 2, 1, 9, 5];

  public readonly id: number;
  public readonly nameJA: string;
  public readonly nameEN: string;
  public readonly nameKO: string;
  public readonly displayOrder: number;
  public readonly imageUrl: string;

  constructor(init: MerchantCategoryInitializer) {
    this.id = init.id;
    this.nameJA = init.nameJA;
    this.nameEN = init.nameEN;
    this.nameKO = init.nameKO;
    this.displayOrder = init.displayOrder;
    this.imageUrl = init.imageUrl;
  }
}
